import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-bar-more-button',
  templateUrl: './bar-more-button.component.html',
  styleUrls: ['./bar-more-button.component.css']
})
export class BarMoreButtonComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
